enum TimesheetType {
  Working,
  HalfDay,
  Holiday
}

export enum TimesheetTypeLabel {
  Working = 'Working',
  HalfDay = 'Half Day',
  Holiday = 'Holiday'
}

export default TimesheetType
